// export const scrollToRow = (rowId) => {
//     const element = document.getElementById(rowId);
//     if (element) {
//         element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
// };

export const scrollToRow = (rowId) => {
    const element = document.getElementById(rowId);
    if (element) {
        const yOffset = -60; // chiều cao header
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }
};